import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=33c48240&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c48240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c48240')) {
      api.createRecord('33c48240', component.options)
    } else {
      api.reload('33c48240', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=33c48240&scoped=true&", function () {
      api.rerender('33c48240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z3p8DU16s86p/JS/comp/Voucher-Unit.vue"
export default component.exports